/**
 * Utilidades de color compartidas en el módulo escape-rooms (backoffice).
 */

export const DEFAULT_ER_ACCENT_HEX = "#7D00FC";

/** Normaliza entrada hex libre (# opcional, 3 o 6 dígitos) a `#rrggbb` o null. */
export function normalizeHexInput(v) {
	if (!v || typeof v !== "string") return null;
	const s = v.trim().replace(/^#/, "");
	if (/^[0-9A-Fa-f]{6}$/.test(s)) return `#${s.toLowerCase()}`;
	if (/^[0-9A-Fa-f]{3}$/.test(s))
		return `#${s[0]}${s[0]}${s[1]}${s[1]}${s[2]}${s[2]}`.toLowerCase();
	return null;
}

/** Acento de la página registro en preview / UI cuando falta o es inválido. */
export function registrationAccentOrDefault(registrationDesign, fallback = DEFAULT_ER_ACCENT_HEX) {
	const n = normalizeHexInput(registrationDesign?.primaryColor || "");
	return n || fallback;
}
